import { render, staticRenderFns } from "./DummyRows.vue?vue&type=template&id=5d9bd858&scoped=true&"
import script from "./DummyRows.vue?vue&type=script&lang=js&"
export * from "./DummyRows.vue?vue&type=script&lang=js&"
import style0 from "./DummyRows.vue?vue&type=style&index=0&id=5d9bd858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bd858",
  null
  
)

export default component.exports